export const COUNTRY_CONFIG_MAP = {
  de: {
    tableShow: {
      plate: true,
      vin: false,
    },
    attribute: {
      primary: 'plate',
    },
    carDetails: {
      mainFeatures: ['plate'],
      secondaryFeatures: ['vin'],
    },
  },
  fr: {
    tableShow: {
      plate: true,
      vin: false,
    },
    attribute: {
      primary: 'plate',
    },
    carDetails: {
      mainFeatures: ['plate'],
      secondaryFeatures: ['vin'],
    },
  },
  it: {
    tableShow: {
      plate: true,
      vin: false,
    },
    attribute: {
      primary: 'plate',
    },
    carDetails: {
      mainFeatures: ['plate'],
      secondaryFeatures: ['vin'],
    },
  },
}
